import moment from 'moment';

import {
	changeReservationStep,
	getReservationTimeWithInterview,
	clearReservationTime,
	initReservationFormData,
	setReservationFormData,
	getReservationDateWithInterview,
} from 'actions/reservation';
import { closeAlert } from 'actions/alert';

import { withAsyncEnterLoader, withAsyncChangeLoader, withLoader } from 'util/routeHelper';
import { serverMapEmpty } from 'util/helper';
import AllCountries from 'util/country';
import { getUser } from 'actions/user';

export default store => ({
	path: 'interview',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'UserInterview',
				),
			store,
			'USER_INTERVIEW',
		),
	},
	onEnter: withAsyncEnterLoader(
		async ({ location: { query: { step = 'reservation' } } }, replace, updateRatio) => {
			store.dispatch(closeAlert('reserve'));

			store.dispatch(changeReservationStep(step));
			updateRatio(0.8);

			// Auto setup reservation form data
			store.dispatch(initReservationFormData());

			await store.dispatch(getUser());

			const { user: { data } } = store.getState();

			store.dispatch(
				setReservationFormData(
					{
						value: serverMapEmpty(data.phone),
						country: AllCountries.getCountryByCode(data.phoneCountry),
					},
					{ value: serverMapEmpty(data.hangout) },
				),
			);

			// Setup reservation time
			store.dispatch(clearReservationTime());
			const today = moment()
				.add(1, 'day')
				.hour(8)
				.minute(0)
				.second(0)
				.format('YYYY-MM-DD HH:mm:ss');

			await Promise.all([
				store.dispatch(getReservationTimeWithInterview(today, 'MORNING')),
				store.dispatch(getReservationTimeWithInterview(today, 'AFTERNOON')),
				store.dispatch(getReservationDateWithInterview(today)),
			]);
		},
		store,
		'ENTER_USER_INTERVIEW',
	),
	onChange: withAsyncChangeLoader(
		async (_, { location: { query: { step = 'reservation' } } }, replace, updateRatio) => {
			store.dispatch(closeAlert('reserve'));
			store.dispatch(changeReservationStep(step));
			updateRatio(0.8);

			if (step === 'reservation') {
				store.dispatch(clearReservationTime());
				const today = moment()
					.add(1, 'day')
					.hour(8)
					.minute(0)
					.second(0)
					.format('YYYY-MM-DD HH:mm:ss');
				await Promise.all([
					store.dispatch(getReservationTimeWithInterview(today, 'MORNING')),
					store.dispatch(getReservationTimeWithInterview(today, 'AFTERNOON')),
					store.dispatch(getReservationDateWithInterview(today)),
				]);
			}
		},
		store,
		'CHANGE_USER_INTERVIEW',
	),
});



// WEBPACK FOOTER //
// ./src/routes/User/Interview/index.js